import { render, staticRenderFns } from "./TableTh.vue?vue&type=template&id=091a7b3c"
var script = {}
import style0 from "./TableTh.vue?vue&type=style&index=0&id=091a7b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports